module.exports = __webpack_public_path__ + "static/media/25.d918d89e.svg";


//////////////////
// WEBPACK FOOTER
// ./src/css/img/newWeatherIcons/25.svg
// module id = 2817
// module chunks = 3